<h2 mat-dialog-title align="center" class="mb-0"> Please download the app to provide the required information for your appointment</h2>
<h5 align="center">Download the app</h5>
<div  mat-dialog-content align="center"> 
  <div class="mb-2 mt-5" align="center">
    <a [href]="data.ios" target="_blank">
      <img src="assets/images/appStoreImg.png" alt="Pawops" height="40">
     </a>
     <a [href]="data.android" target="_blank">
      <img src="assets/images/googlePlayImg.png" alt="Pawops" height="40">
     </a>
 </div>
</div>
<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close  class="btn btn-custom m-4">Ok</button>
</mat-dialog-actions>